export const SENDER_ID = process.env.FCM_SENDER_ID;
export const PUBLIC_VAPI_KEY = process.env.FCM_PUBLIC_VAPI_KEY;
export const PROJECT_ID = process.env.FCM_PROJECT_ID;
export const API_KEY = process.env.FCM_API_KEY;
export const APP_ID = process.env.FCM_APP_ID;
export const AUTH_DOMAIN = process.env.FCM_AUTH_DOMAIN;
export const STORAGE_BUCKET = process.env.FCM_STORAGE_BUCKET;

export const FIREBASE_CONFIG = Object.freeze({
    apiKey: API_KEY,
    authDomain: AUTH_DOMAIN,
    projectId: PROJECT_ID,
    storageBucket: STORAGE_BUCKET,
    messagingSenderId: SENDER_ID,
    appId: APP_ID,
});


// WEBPACK FOOTER //
// ./src/constants/fcm.js